import Icons from "../../icons/sidebar";
import { ROUTES } from "../../routes/route.constants";

export interface IGroupMenu extends IMenuItem {
  isGroup?: boolean;
  menuItems?: IMenuItem[];
  permissions?: string[];
  users?: string[];
}

export interface IMenuItem {
  title: string;
  Icon?: any;
  hasNewFeature?: boolean;
  path: string;
  subMenu?: IMenuItem[] | IGroupMenu[];
  permissions?: string[];
  users?: string[];
  categories?: string[];
  category?: string;
  isHeading?: boolean;
}

const MenuList: IMenuItem[] = [
  {
    title: "Overview",
    Icon: Icons.DashboardIcon,
    path: `/${ROUTES.DASHBOARD.PATH}`,
  },
  {
    title: "Inventory",
    isHeading: true,
    path: "",
  },
  {
    title: "Purchase Orders",
    Icon: Icons.PurchaseOrdersIcon,
    path: `/${ROUTES.INVENTORY.PATH}/${ROUTES.INVENTORY.PURCHASE_ORDERS}`,
  },
  {
    title: "Inventory Received",
    Icon: Icons.InventoryOutlinedIcon,
    path: `/${ROUTES.INVENTORY.PATH}/${ROUTES.INVENTORY.INVENTORY_RECEIVED}`,
  },
  {
    title: "Sales",
    Icon: Icons.AlignVerticalTopIcon,
    path: `/${ROUTES.INVENTORY.PATH}/${ROUTES.INVENTORY.SALES}`,
  },
  {
    title: "Credit Management",
    Icon: Icons.CreditScoreIcon,
    path: `/${ROUTES.INVENTORY.PATH}/${ROUTES.INVENTORY.CREDIT_MANAGEMENT}`,
  },
  {
    title: "Expenses Management",
    Icon: Icons.ChromeReaderModeIcon,
    path: `/${ROUTES.INVENTORY.PATH}/${ROUTES.INVENTORY.EXPENSES_MANAGEMENT}`,
  },
  {
    title: "Reporting and Analysis",
    Icon: Icons.AnalyticsIcon,
    path: `/${ROUTES.REPORTS.PATH}`,
    subMenu: [
      {
        isGroup: true,
        title: "Credit Management",
        path: `/${ROUTES.REPORTS}/${ROUTES.REPORTS.CREDIT_MANAGEMENT.PATH}`,
        menuItems: [
          {
            path: `/${ROUTES.REPORTS.PATH}/${ROUTES.REPORTS.CREDIT_MANAGEMENT.PATH}/${ROUTES.REPORTS.CREDIT_MANAGEMENT.UNPAID_INVOICES}`,
            title: "Unpaid Invoices",
          },
          {
            path: `/${ROUTES.REPORTS.PATH}/${ROUTES.REPORTS.CREDIT_MANAGEMENT.PATH}/${ROUTES.REPORTS.CREDIT_MANAGEMENT.CREDIT_ACTIVITY}`,
            title: "Credit Activity",
          },
          {
            path: `/${ROUTES.REPORTS.PATH}/${ROUTES.REPORTS.CREDIT_MANAGEMENT.PATH}/${ROUTES.REPORTS.CREDIT_MANAGEMENT.PAYMENT_TRENDS}`,
            title: "Payment Trends",
          },
          {
            path: `/${ROUTES.REPORTS.PATH}/${ROUTES.REPORTS.CREDIT_MANAGEMENT.PATH}/${ROUTES.REPORTS.CREDIT_MANAGEMENT.VISUALIZATION}`,
            title: "Visualization",
          },
        ],
      },
      {
        isGroup: true,
        title: "Expenses Reports",
        path: `/${ROUTES.REPORTS}/${ROUTES.REPORTS.EXPENSES.PATH}`,
        menuItems: [
          {
            path: `/${ROUTES.REPORTS.PATH}/${ROUTES.REPORTS.EXPENSES.PATH}/${ROUTES.REPORTS.EXPENSES.REGISTER}`,
            title: "Expenses Register",
          },
          {
            path: `/${ROUTES.REPORTS.PATH}/${ROUTES.REPORTS.EXPENSES.PATH}/${ROUTES.REPORTS.EXPENSES.CATEGORY_SUMMARY}`,
            title: "Category Summary Report",
          },
          {
            path: `/${ROUTES.REPORTS.PATH}/${ROUTES.REPORTS.EXPENSES.PATH}/${ROUTES.REPORTS.EXPENSES.CASH_ACCOUNT_SUMMARY}`,
            title: "Cash Account Summary Report",
          },
          {
            path: `/${ROUTES.REPORTS.PATH}/${ROUTES.REPORTS.EXPENSES.PATH}/${ROUTES.REPORTS.EXPENSES.VISUALIZATION}`,
            title: "Visualization",
          },
          // {
          //   path: `/${ROUTES.REPORTS.PATH}/${ROUTES.REPORTS.EXPENSES.PATH}/${ROUTES.REPORTS.EXPENSES.EXPENSE_TREND}`,
          //   title: "Expense Trend",
          // },
        ],
      },
    ],
  },

  /**
   * CONFIGURATION
   */
  {
    title: "Configurations",
    isHeading: true,
    path: "",
  },
  {
    title: "items",
    Icon: Icons.ItemsIcon,
    path: `/${ROUTES.CONFIGURATION.PATH}/${ROUTES.CONFIGURATION.ITEMS}`,
  },
  {
    title: "item Categories",
    Icon: Icons.CategoryOutlinedIcon,
    path: `/${ROUTES.CONFIGURATION.PATH}/${ROUTES.CONFIGURATION.ITEM_CATEGORIES}`,
  },
  {
    title: "Suppliers",
    Icon: Icons.SuppliersIcon,
    path: `/${ROUTES.CONFIGURATION.PATH}/${ROUTES.CONFIGURATION.SUPPLIERS}`,
  },
  {
    title: "Customers",
    Icon: Icons.GroupsIcon,
    path: `/${ROUTES.CONFIGURATION.PATH}/${ROUTES.CONFIGURATION.CUSTOMERS}`,
  },
  {
    title: "Branches",
    Icon: Icons.CorporateFareIcon,
    path: `/${ROUTES.CONFIGURATION.PATH}/${ROUTES.CONFIGURATION.BRANCHES}`,
  },
  {
    title: "Staff",
    Icon: Icons.PeopleAltIcon,
    path: `/${ROUTES.CONFIGURATION.PATH}/${ROUTES.CONFIGURATION.STAFF}`,
  },
  {
    title: "Payment Accounts",
    Icon: Icons.AccountBalanceWalletIcon,
    path: `/${ROUTES.CONFIGURATION.PATH}/${ROUTES.CONFIGURATION.PAYMENT_ACCOUNTS}`,
  },
  {
    title: "Expenses Categories",
    Icon: Icons.BallotIcon,
    path: `/${ROUTES.CONFIGURATION.PATH}/${ROUTES.CONFIGURATION.EXPENSES_CATEGORIES}`,
  },
];

export default MenuList;

export const AdminMenuList: IMenuItem[] = [
  {
    title: "Dashboard",
    Icon: Icons.DashboardIcon,
    path: `/${ROUTES.ADMIN.PATH}/${ROUTES.ADMIN.DASHBOARD}`,
  },
  {
    title: "Businesses",
    Icon: Icons.AccountBalanceIcon,
    path: `/${ROUTES.ADMIN.PATH}/${ROUTES.ADMIN.BUSINESSES}`,
  },
  {
    title: "Business Admins",
    Icon: Icons.SupervisorAccountIcon,
    path: `/${ROUTES.ADMIN.PATH}/${ROUTES.ADMIN.BUSINESS_ADMINS}`,
  },
];
